import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

class WelcomeCompany extends Component {
  constructor() {
    super();
    this.state = {
      alert: '',
      code: '',
      image: '',
      loading: true,
      errors: {},
    };
  }

  componentDidMount() {
    axios
      .get('/company')
      .then((res) => {
        const cred = res.data.credentials;
        console.log(cred);
        this.setState({ code: cred.companyCode });
        this.setState({ loading: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  render() {
    if (this.state.loading) return null;
    return (
      <>
        <div className='upload-photo-page justify-content-center row'>
          <div className='upload-photo-col'>
            <div className='row'>
              <img
                className='landing-logo'
                src='../Images/successrocketlogo.png'
                alt='Landing Logo'
              />
            </div>
            <div className='row mt-4'>
              <p className='choose-manager-text'>
                Before you get started, send this code to your employees so they
                can start tracking their success.
              </p>
              <h5>{this.state.code}</h5>
            </div>
            <div className='row justify-content-center '>
              <button className='sign-btn next-step-btn'>
                <Link to='/company' className='signin-link'>
                  Done
                </Link>
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default WelcomeCompany;
